<template>
	<v-dialog v-model="isVisible" max-width="800" persistent>
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Editar Compañía
			</p-header-dialog>
			<div class="tw-flex tw-p-10">
				<div class=" px-3 tw-w-1/3">
					<v-layout row
						class="section-information"
						:style="`background-color:${$appColors.primary}`">
						<v-flex xs12 mb-3>
							<div class="wrapper-user-image">
								<div class="wrapper-user">
									<img 
										:src="urlImage" 
										alt="user"
										height="100%"
										width="100%">
								</div>
								<div class="wrapper-camera">
									<load-input
										:show-input="false"
										:id-company="company.id"
										icon="camera_alt"
										color="white"
										class-btn="circle-btn"
										@input="getImage"
									/>
								</div>
							</div>
						</v-flex>
					</v-layout>
				</div>
				<div class="px-3 tw-w-2/3">
					<section class="form-company">
						<v-layout row tw-justify-between tw-gap-x-2>
							<v-flex xs6 tw-pr-1>
								<label :style="`color:${$appColors.info}`">
									Nombre de la Compañía
									<input
										class="form-company-input"
										placeholder="Nombre"
										v-model="companyEdit.name"
									/>
								</label>
							</v-flex>
							<v-flex xs6>
								<label :style="`color:${$appColors.info}`">
									Código
									<input
										class="form-company-input"
										placeholder="Código"
										v-model="companyEdit.aclCode"
										readonly
									/>
								</label>
							</v-flex>
						</v-layout>
						<v-layout row tw-justify-between tw-gap-x-2>
							<v-flex xs6>
								<label :style="`color:${$appColors.info}`">
									Teléfono
									<input
										class="form-company-input"
										placeholder="Teléfono"
										type="number"
										v-model="companyEdit.additionalInformation.phone"
									/>
								</label>
							</v-flex>
							<v-flex xs6 tw-pr-1>
								<label :style="`color:${$appColors.info}`">
									Integraciones
									<v-select
										class="select-core"
										hide-details
										clearable
										height="17"
										outline
										single-line
										:items="platforms"
										item-value="id"
										item-text="name"
										multiple
										v-model="companyEdit.assignedPlatforms"
										return-object>
									</v-select>
								</label>
							</v-flex>
						</v-layout>
					</section>
				</div>
			</div>
			<p-horizontal-divider></p-horizontal-divider>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					type="primary"
					@click="saveDataCompany"
					> Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import loadInput from '@/components/configuration/companies/load-file-input';

export default {
	name: 'edit-company-dialog',
	created() {
		// ! Carga directamente de los valores del prop company a la variable creada aqui.
		// this.companyEdit.additionalInformation.phone =
		// this.company.additionalInformation && this.company.additionalInformation.phone
		// 		? this.company.additionalInformation.phone : null;
		// this.companyEdit.name = this.company.name;
		// this.companyEdit.aclCode = this.company.aclCode;
	},
	components: { PHeaderDialog, PButton, CloseIcon, PCard, PHorizontalDivider, loadInput },
	data() {
		return {
			isVisible: false,
			urlImage: '',
			companyEdit: {
				additionalInformation: {
					phone: null,
				},
				name: null,
				aclCode: null,
				assignedPlatforms: [],
			},
		};
	},
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		getImage(url) {
			this.urlImage = url;
		},
		saveDataCompany() {
			this.companyEdit.assignedPlatforms = this.companyEdit.assignedPlatforms.map(p => ({
				id: p.id,
				code: p.code,
				name: p.name,
			}));
			this.$emit('saveDataCompany', this.companyEdit);
			this.isVisible = false;
		},
	},
	props: {
		company: {
			type: Object,
			default: () => {},
		},
		platforms: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		company: {
			handler(newVal) {
				this.companyEdit.additionalInformation.phone =
					newVal.additionalInformation && newVal.additionalInformation.phone
						? newVal.additionalInformation.phone : null;
				this.companyEdit.name = newVal.name;
				this.companyEdit.aclCode = newVal.aclCode;
				this.urlImage = newVal.urlImage.web ? newVal.urlImage.web : 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
				this.companyEdit.assignedPlatforms = newVal.assignedPlatforms;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.form-company {
	bottom: 0;
	left: 0;
	padding: 10px;
	position: relative !important;
	right: 0;

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
        display: block;
        outline: none;
		color: map-get($colors, secondary);
		margin-top: 4px;
		padding: 10px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
.section-information {
	align-content: flex-start;
	align-items: flex-start;
	border: 1px solid color(gray);
	border-radius: 8px;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02);
	color: color(white);
	height: 100%;
	margin-left: auto;
	padding: 26px 36px;
}
.wrapper-user {
	border-radius: 50%;
	height: 100px;
	margin: auto;
	overflow: hidden;
	width: 100px;
}

.text {
	font-size: size(large);
	text-align: center;
}

.wrapper-user-image {
	position: relative;
}

.wrapper-camera {
	bottom: -1px;
	position: absolute;
	right: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/companies/edit-company-dialog.vue